/** Demo fixtures shared by the Shopping Cart pages. */

export const IMG_1 = require('../../../../../assets/cls-dk/products/product-1-1.jpg');
export const IMG_2 = require('../../../../../assets/cls-dk/products/product-2-1.jpg');
export const IMG_3 = require('../../../../../assets/cls-dk/products/product-4-1.jpg');
export const IMG_4 = require('../../../../../assets/cls-dk/products/product-6-1.jpg');
export const IMG_5 = require('../../../../../assets/cls-dk/products/product-8-1.jpg');
export const PACKAGE_IMG = require('../../../../../assets/cls-dk/products/product-9-1.jpg');

export const INCLUDED_PRODUCTS = [
  { image: IMG_1, title: 'Royal Hoodie', subtitle: 'Red, S, Archie' },
  { image: IMG_2, title: 'Royal Unisex Tee', subtitle: 'Red, S, Archie' },
  { image: IMG_3, title: 'Mavetaske', subtitle: 'Red, S, Archie' },
  { image: IMG_4, title: 'Bøllehat' },
  { image: IMG_5, title: 'Regnponcho' },
];
